import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React, { useEffect, useState } from 'react';
import Form from '../../../form';
import FormFieldBase from '../../../form/field/FieldBase';
import DataGridApi from '../../../data/actions/grid';
import placeholders from '../../../data/placeholders';
import ContactUtils from '../../../utils/contact';
import FormControl from '@material-ui/core/FormControl';
/**@param {import('./types').ContactsSelectFieldProps} props */

var ContactsSelectFormField = function ContactsSelectFormField(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      onBlur = _ref$input.onBlur,
      onFocus = _ref$input.onFocus,
      restInput = _objectWithoutProperties(_ref$input, ["name", "value", "onChange", "onBlur", "onFocus"]),
      meta = _ref.meta,
      required = _ref.required,
      itemsPerPage = _ref.itemsPerPage,
      formControlProps = _ref.formControlProps,
      variant = _ref.variant,
      fullWidth = _ref.fullWidth,
      margin = _ref.margin,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "required", "itemsPerPage", "formControlProps", "variant", "fullWidth", "margin"]);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      contactsError = _useState2[0],
      setContactsError = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      listsError = _useState4[0],
      setListsError = _useState4[1];

  var listType = 'list';
  var contactType = 'contactCrm';
  var style = {};

  if (rest && rest.style) {
    style = _objectSpread({}, rest.style);
  }

  var icon = false;

  if (rest && rest.icon) {
    icon = rest.icon;
  }

  var showMetaError = (meta.submitError && !meta.dirtySinceLastSubmit || meta.error) && meta.touched;
  var metaErrorText = '';
  if (showMetaError && meta.error) metaErrorText = "".concat(meta.error, " ");

  var loadContacts = function loadContacts() {
    return DataGridApi().load({
      id: 'select-' + contactType,
      dataType: contactType,
      page: 0,
      itemsPerPage: itemsPerPage,
      dataProps: {}
    }).then(function (contactData) {
      var hasValues = contactData.payload && contactData.payload.Data && contactData.payload.Data.length > 0;

      if (hasValues) {
        return contactData.payload.Data.map(function (item) {
          return {
            icon: icon ? placeholders('{icon}', {
              dataType: contactType
            }, item) : undefined,
            item: item,
            label: placeholders('{label}', {
              dataType: contactType
            }, item),
            value: item[contactData.view.idKeyProp]
          };
        });
      }
    }).catch(function (err) {
      console.error(err);
      setContactsError('An error has occurred while retrieving the contacts. ');
    });
  };

  var loadContactLists = function loadContactLists() {
    return DataGridApi().load({
      id: 'select-' + listType,
      dataType: listType,
      page: 0,
      itemsPerPage: itemsPerPage,
      dataProps: {}
    }).then(function (listData) {
      var hasValues = listData.payload && listData.payload.Data && listData.payload.Data.length > 0;

      if (hasValues) {
        return listData.payload.Data.map(function (item) {
          return {
            icon: icon ? placeholders('{icon}', {
              dataType: listType
            }, item) : undefined,
            item: item,
            label: placeholders('{label}', {
              dataType: listType
            }, item),
            value: "{ContactListId:".concat(item[listData.view.idKeyProp], "}")
          };
        });
      }
    }).catch(function (err) {
      console.error(err);
      setListsError('An error has occurred while retrieving the lists. ');
    });
  };

  var onLoad =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var listOptions, contactOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadContactLists();

            case 2:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.t0 = [];

            case 5:
              listOptions = _context.t0;
              _context.next = 8;
              return loadContacts();

            case 8:
              _context.t1 = _context.sent;

              if (_context.t1) {
                _context.next = 11;
                break;
              }

              _context.t1 = [];

            case 11:
              contactOptions = _context.t1;
              return _context.abrupt("return", [{
                label: 'Lists',
                options: listOptions
              }, {
                label: 'Contacts',
                options: contactOptions
              }]);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onLoad() {
      return _ref2.apply(this, arguments);
    };
  }();

  var showRetrievalError = contactsError !== '' || listsError !== '';
  return React.createElement(React.Fragment, null, React.createElement(FormControl, Object.assign({}, formControlProps, {
    fullWidth: fullWidth,
    margin: margin
  }), React.createElement("div", {
    style: style
  }, React.createElement(Form.Input.MultiSelect, Object.assign({
    onChange: onChange,
    onLoad: onLoad,
    textFieldProps: {
      helperText: showRetrievalError ? metaErrorText.concat("".concat(listsError).concat(contactsError)) : metaErrorText,
      error: showMetaError || showRetrievalError,
      required: required,
      inputProps: _objectSpread({}, restInput)
    },
    variant: variant
  }, rest)))));
};

var ContactsSelectField = function ContactsSelectField(props) {
  return React.createElement(FormFieldBase, Object.assign({
    label: props.name
  }, props));
};

ContactsSelectField.defaultProps = {
  component: ContactsSelectFormField,
  formControlProps: {
    style: {
      marginTop: 4
    }
  },
  margin: 'normal',
  fullWidth: true,
  itemsPerPage: 20,
  label: '',
  variant: 'filled'
};
export default ContactsSelectField;